import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import { ensureSession } from '@/auth';
import {
  appPerfMark,
  appPerfMeasure,
  appPerfSinceMyProfile,
  appPerfScheduleFirstPaint
} from '@/utils/appBootstrapPerfLog.js';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  appPerfMark('router:beforeEach', { from: from.path, to: to.path, name: to.name });
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  let nextLocation = null;

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(
    (el) => el.parentNode.removeChild(el)
  );

  //login 페이지로 이동 요청 시 무한루프 방지
  if (to.name === 'Login') {
    const authed = await ensureSession();
    if (authed) {
      return next({ name: 'dashboard' });
    }
    return next();
  }

  const authorized = await (async () => {
    appPerfMark('router:ensureSession:start');
    const ok = await ensureSession();
    appPerfMeasure('router:ensureSession', 'router:ensureSession:start', { ok });
    return ok;
  })();

  if (!authorized) {
    console.error('인증 실패! 로그인 페이지로 이동합니다.');
    nextLocation = { name: 'Login' };
  }

  // 역할 기반 접근 제어 (프로필은 ensureSession 이 채운 뒤)
  if (authorized) {
    const isAdmin = store.getters['user/isAdmin'];
    const isUser = store.getters['user/isUser'];

    // 회사 관리 페이지 접근 제어
    if (to.path.startsWith('/admin/companies')) {
      if (!isAdmin) {
        nextLocation = { path: '/dashboard' };
      }
    }

    // 담당자 관리 페이지 접근 제어
    if (to.path.startsWith('/admin/company-managers')) {
      if (!isAdmin) {
        nextLocation = { path: '/dashboard' };
      }
    }

    // 사용자 관리 페이지 접근 제어
    if (to.path.startsWith('/admin/users')) {
      if (!isAdmin && !isUser) {
        nextLocation = { path: '/dashboard' };
      }
    }

    // 프로젝트 관련 페이지 접근 제어 (관리자만)
    if (to.path.startsWith('/admin/project') ||
        to.path.startsWith('/admin/report') ||
        to.path.startsWith('/admin/ai') ||
        to.path.startsWith('/admin/site')) {
      if (!isAdmin) {
        nextLocation = { path: '/dashboard' };
      }
    }
  }

  //metaTags가 없으면 아래의 코드를 실행하지 않도록 처리
  if (nearestWithMeta) {
    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags
      .map((tagDef) => {
        const tag = document.createElement('meta');
        Object.keys(tagDef).forEach((key) => {
          tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
      })
      // Add the meta tags to the document head.
      .forEach((tag) => document.head.appendChild(tag));
  }
  return next(nextLocation ? nextLocation : undefined);
});

router.afterEach((to, from) => {
  appPerfMeasure('router:afterEach', 'router:beforeEach', {
    name: to.name,
    path: to.path
  });
  appPerfSinceMyProfile(`router:ready:${to.name || to.path}`);
  appPerfScheduleFirstPaint(`route:${to.name || to.path}`, { path: to.path });
});

// import BRoutes from '...'
// router.addRoutes(BRoutes);

//Auto....
const routes = require.context('../routes', true, /[A-Za-z0-9-_,\s]+\.js$/i);
routes.keys().forEach((key) => {
  const matched = key.match(/([A-Za-z0-9-_]+)\./i);
  console.log(matched);
  if (matched && matched.length > 1) {
    const k = matched[1];
    const v = routes(key);
    console.log('routes : ../routes/' + k + '.js', v);
    // DEPRECATED: use router.addRoute() instead.
    // router.addRoutes(v.default);
    v.default.forEach((route) => {
      router.addRoute(route);
    });
  }
});

export default router;
